import React, { ChangeEvent } from "react";
import { Dropdown } from "../../../components/Dropdown";
import { TooltipButton } from "../ChatInput";
import classNames from 'classnames';
import { Badge, Icon, IconButton, Switch, Heading } from "../../../components/base";
import { IMCPTool } from "../../../libs/models/app/mcp/Tool";
import { useDispatch } from "react-redux";
import { showSettingDialog } from "../../../redux/features/app/appSlice";
import { Button } from "../../../components/Button";
import { DropdownHeader } from "../../../components/DropdownHeader";
import { useApp } from "../../../libs/hooks/useApp";

interface ToolListProps {
  data: Record<string, IMCPTool[]>;
}

export const ToolList: React.FC<ToolListProps> = ({ data }) => {
  //const [mcpTools, setMcpTools] = React.useState<Record<string,MCPTool[]>>({});
  // mcp 드롭다운 상태관리
  const [dropdownState, setDropDownState] = React.useState(false);
  const [detailPopId, setDetailPopId] = React.useState<string | null>(null);
  const dispatch = useDispatch();

  const apps = useApp();

  const changedDropDownState = (state: boolean) => {
    setDropDownState(state);
    if(!state) changedDetailPopId(null);
  };
  const changedDetailPopId = (id: string | null) => {
    setDetailPopId(id);
  };

  const changedMcpToolState = (event: ChangeEvent<HTMLInputElement>) => {
    apps.changedMcpToolState(event.target.id.split("__")[0], event.target.id.split("__")[1], event.target.checked);
  }

  const changedMcpServerState = (event: ChangeEvent<HTMLInputElement>) => {
    apps.changedMcpServerState(event.target.id, event.target.checked);
  }


  return (
    <div className="chat-mcp">
      <Dropdown
        isOpen={dropdownState}
        changeState={changedDropDownState}
        position="top"
        mode="hover"
        trigger={
          <TooltipButton message="MCP를 이용해보세요" icon="settings" textBlind={true} />
        }
      >
        <div className="mcp-server-list">
            <DropdownHeader title={<div>
              {detailPopId && <IconButton size="medium" name={'prev'} onClick={()=>{changedDetailPopId(null)}}> 뒤로가기 </IconButton> }
              MCP 서버
            </div>}>
              <div className="dsx-side-right">
                <Button
                  classOnly="chat-button-edit"
                  onClick={() => {
                    dispatch(showSettingDialog({visible: true, type: 2}));
                  }}
                >
                  상세보기
                </Button>
              </div>
            </DropdownHeader>
          <div className="mcp-server-list-box">
          {!detailPopId ? 
            Object.entries(data).map(([server, value]) => (
            <React.Fragment key={server}>
              {(
                <div key={server} className={classNames('mcp-server-list-item')}>
                  <a
                    className="mcp-server-item"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      changedDetailPopId(server);
                    }}
                  >
                    <MCPServerItem server={server} tools={value} size="body2" switchPosition="right" switchId={server} onClick={changedMcpServerState} /> 
                    <Icon name='chevron'></Icon>
                  </a>
                </div>
              )}

            </React.Fragment>
            ))
            : (Object.entries(data[detailPopId]).map(([_server, tool]) => (
                <div key={tool.name} className={classNames('mcp-server-list-item')}>
                  <MCPToolItem server={detailPopId} name={tool.id ?? tool.name} size="body2"  textOnly={false} switchPosition="right" switchChecked={tool.enabled} switchId={tool.name} onClick={changedMcpToolState} />
              </div>
              )))
          }
          </div>
        </div>

      </Dropdown>
    </div>
  )
}

export const MCPServerItem: React.FC<{server: string,  tools: IMCPTool[], size: 'heading3' | 'title3' | 'title2' | 'body1' |'body2' |'body3', weight?: 'bold' | 'semibold' | 'medium' | 'regular', textOnly?: boolean, switchPosition?: 'left' | 'right', switchId?: string, onClick?: (event: ChangeEvent<HTMLInputElement>) => void}> = ({ server, tools, size, weight='bold', switchPosition, textOnly=false, switchId, onClick }) => {
  
  const onChanged = (event: ChangeEvent<HTMLInputElement>) => {
    if(onClick) {
      onClick(event);
    }
  }
  
  return (
    <div className="mcp-server-item">
      <div className='server-name'>
        {!textOnly && <Badge accent='normal'>{server.slice(0, 1)}</Badge>}
        {switchPosition == 'left' && <Switch id={switchId} checked={tools.length == tools.filter(c => c.enabled).length} onChange={onChanged}></Switch>}
        <Heading size={size} weight={weight}>{server}</Heading>
      </div>
      {switchPosition == 'right' && <div className='server-tool-count'>
        {tools.length == tools.filter(c => c.enabled).length || tools.filter(c => c.enabled).length == 0 ?
          <div onClick={(e) => {
              e.stopPropagation();
          }}>
            <Switch id={server} checked={tools.length == tools.filter(c => c.enabled).length} onChange={onChanged}></Switch>
          </div>
        : <Badge
            round
            accent='primary'
            className='tool-count'>{tools.filter(c => c.enabled).length} in {tools.length}</Badge>
        }
      </div>}
    </div>
  )
}

export const MCPToolItem: React.FC<{server: string, name: string, size: 'heading3' | 'title3' | 'title2' | 'body1' |'body2' |'body3', weight?: 'bold' | 'semibold' | 'medium' | 'regular', textOnly?: boolean, switchPosition?: 'left' | 'right', switchChecked?: boolean, switchId?: string, onClick?: (event: ChangeEvent<HTMLInputElement>) => void}> = ({ server,name, size, weight='bold', switchPosition, textOnly=false, switchChecked=false, switchId, onClick }) => {
  
  const onChanged = (event: ChangeEvent<HTMLInputElement>) => {
    if(onClick) {
      onClick(event);
    }
  }
  
  return (
    <div className="mcp-server-item">
      <div className='server-name'>
        {!textOnly && <Badge accent='normal'>{server.slice(0, 1)}</Badge>}
        {switchPosition == 'left' && <Switch id={switchId} checked={switchChecked} onChange={onChanged}></Switch>}
        <Heading size={size} weight={weight}>{name}</Heading>
      </div>
      {switchPosition == 'right' && <Switch id={switchId} checked={switchChecked} onChange={onChanged}></Switch>}
    </div>
  )
}